import { useState, type FormEvent, type ReactNode } from "react";
import { Boton, Campo } from "../atoms";
import estilos from "./Encabezado.module.css";

/** Título de la página (el único h1), su bajada y, opcionalmente, algo al costado. */
export function EncabezadoPagina({
  titulo,
  subtitulo,
  lateral,
}: {
  readonly titulo: ReactNode;
  readonly subtitulo?: ReactNode;
  readonly lateral?: ReactNode;
}) {
  return (
    <div className={estilos.encabezado}>
      <div>
        <h1>{titulo}</h1>
        {subtitulo && <p className={estilos.subtitulo}>{subtitulo}</p>}
      </div>
      {lateral && <div className={estilos.lateral}>{lateral}</div>}
    </div>
  );
}

/** Buscador que se envía (Inicio): lleva a otra página con la consulta. */
export function BuscadorConBoton({
  rotulo,
  placeholder,
  textoBoton,
  alBuscar,
}: {
  readonly rotulo: string;
  readonly placeholder: string;
  readonly textoBoton: string;
  readonly alBuscar: (consulta: string) => void;
}) {
  const [consulta, setConsulta] = useState("");
  function enviar(e: FormEvent) {
    e.preventDefault();
    alBuscar(consulta.trim());
  }
  return (
    <form className={estilos.buscador} role="search" onSubmit={enviar}>
      <Campo
        rotulo={rotulo}
        rotuloOculto
        type="search"
        placeholder={placeholder}
        autoComplete="off"
        value={consulta}
        onChange={(e) => {
          setConsulta(e.target.value);
        }}
      />
      <Boton type="submit">{textoBoton}</Boton>
    </form>
  );
}

/** Buscador que filtra mientras se escribe. */
export function CampoBusqueda({
  rotulo,
  placeholder,
  valor,
  alCambiar,
}: {
  readonly rotulo: string;
  readonly placeholder: string;
  readonly valor: string;
  readonly alCambiar: (valor: string) => void;
}) {
  return (
    <Campo
      className={estilos.campoBusqueda}
      rotulo={rotulo}
      rotuloOculto
      type="search"
      placeholder={placeholder}
      autoComplete="off"
      value={valor}
      onChange={(e) => {
        alCambiar(e.target.value);
      }}
    />
  );
}

/** Contenido plegable con su resumen («Cómo funciona»). */
export function Plegable({ resumen, children }: { readonly resumen: string; readonly children: ReactNode }) {
  return (
    <details className={estilos.plegable}>
      <summary>{resumen}</summary>
      <div className={estilos.contenidoPlegable}>{children}</div>
    </details>
  );
}
